export const endpoints = {
	search: "/api/search",
	products: "/api/products/filterV2",
	filterProducts: "/api/products/filterV2"
}
